import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";
import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";
import { areRoutesChanged } from "./AreRoutesChanged";

export function isDisabledForSpdr(
  spdrId: number | undefined,
  project: ProjectViewModel,
  stopDataOfSpdrsOrPdsrs: number[],
  ltlPipeline?: LtlPipelineViewModel
) {
  const selectedLtlSpdrId = spdrId;
  if (
    areRoutesChanged(
      selectedLtlSpdrId,
      project.FTLRoutes,
      project.TemplateFTLRoutes
    )
  ) {
    return true;
  }

  if (selectedLtlSpdrId && stopDataOfSpdrsOrPdsrs.includes(selectedLtlSpdrId)) {
    return true;
  }
  return (
    ltlPipeline !== undefined &&
    ltlPipeline.routing !== undefined &&
    ltlPipeline.routing.length > 0
  );
}
